/* MemoriesxBloom — ambient petal drift.
   Lightweight canvas 2D particle field. Pauses when offscreen or hidden,
   skips entirely under prefers-reduced-motion. */
(function () {
  'use strict';

  var PALETTE = [
    [229, 195, 198], // rose soft
    [183, 110, 121], // dusty rose
    [243, 227, 226], // whisper
    [240, 232, 221]  // sand
  ];

  function PetalField(host) {
    this.host = host;
    this.canvas = document.createElement('canvas');
    this.ctx = this.canvas.getContext('2d');
    host.appendChild(this.canvas);
    this.petals = [];
    this.running = false;
    this.visible = false;
    this.tick = this.tick.bind(this);
    this.resize = this.resize.bind(this);

    this.resize();
    window.addEventListener('resize', this.resize);

    var self = this;
    new IntersectionObserver(function (entries) {
      self.visible = entries[0].isIntersecting;
      self.toggle();
    }).observe(host);

    document.addEventListener('visibilitychange', function () {
      self.toggle();
    });
  }

  PetalField.prototype.resize = function () {
    var rect = this.host.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    this.w = Math.max(rect.width, 1);
    this.h = Math.max(rect.height, 1);
    this.canvas.width = this.w * dpr;
    this.canvas.height = this.h * dpr;
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    var density = parseFloat(this.host.dataset.mxbPetalDensity || '1');
    var count = Math.round((this.w < 750 ? 12 : 24) * density);
    this.petals = [];
    for (var i = 0; i < count; i++) this.petals.push(this.spawn(true));
  };

  PetalField.prototype.spawn = function (anywhere) {
    var size = 5 + Math.random() * 9;
    return {
      x: Math.random() * this.w,
      y: anywhere ? Math.random() * this.h : -size * 2,
      size: size,
      vy: 0.25 + Math.random() * 0.55,
      sway: 18 + Math.random() * 26,
      swaySpeed: 0.4 + Math.random() * 0.7,
      phase: Math.random() * Math.PI * 2,
      rot: Math.random() * Math.PI * 2,
      vr: (Math.random() - 0.5) * 0.012,
      color: PALETTE[(Math.random() * PALETTE.length) | 0],
      alpha: 0.22 + Math.random() * 0.34,
      t: Math.random() * 1000
    };
  };

  PetalField.prototype.toggle = function () {
    var shouldRun = this.visible && !document.hidden;
    if (shouldRun && !this.running) {
      this.running = true;
      requestAnimationFrame(this.tick);
    } else if (!shouldRun) {
      this.running = false;
    }
  };

  PetalField.prototype.tick = function () {
    if (!this.running) return;
    var ctx = this.ctx;
    ctx.clearRect(0, 0, this.w, this.h);

    for (var i = 0; i < this.petals.length; i++) {
      var p = this.petals[i];
      p.t += 0.016;
      p.y += p.vy;
      p.rot += p.vr;
      var x = p.x + Math.sin(p.phase + p.t * p.swaySpeed) * p.sway;

      if (p.y > this.h + p.size * 2) {
        this.petals[i] = this.spawn(false);
        continue;
      }

      ctx.save();
      ctx.translate(x, p.y);
      ctx.rotate(p.rot + Math.sin(p.t * p.swaySpeed) * 0.35);
      ctx.globalAlpha = p.alpha;
      ctx.fillStyle = 'rgb(' + p.color[0] + ',' + p.color[1] + ',' + p.color[2] + ')';
      drawPetal(ctx, p.size);
      ctx.restore();
    }

    requestAnimationFrame(this.tick);
  };

  /* A single petal: two soft bezier lobes meeting at a point. */
  function drawPetal(ctx, s) {
    ctx.beginPath();
    ctx.moveTo(0, -s);
    ctx.bezierCurveTo(s * 0.9, -s * 0.6, s * 0.7, s * 0.7, 0, s);
    ctx.bezierCurveTo(-s * 0.7, s * 0.7, -s * 0.9, -s * 0.6, 0, -s);
    ctx.closePath();
    ctx.fill();
  }

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-mxb-petals]').forEach(function (host) {
      if (!host.dataset.mxbPetalsInit) {
        host.dataset.mxbPetalsInit = 'true';
        new PetalField(host);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
